import React from "react";
import Button from "../../../components/Habitacional/core/Button/Button";

import { ReactComponent as Illustration } from "../../../assets/images/home/business.svg";

import ContentSection from "../../../components/Habitacional/ContentSection";

const BusinessSection = () => {
  return (
    <ContentSection
      title="Seguro Empresarial"
      description="Conheça as vantagens, onde comprar, as coberturas, os serviços de assistência, como acionar o seguro e as condições gerais."
      illustration={<Illustration />}
    >
      <Button
        variant="primary"
        style={{ marginTop: "32px" }}
        onClick={() => {
          window.open("/pj/mge/Paginas/Seguro-Empresarial.aspx", "_blank");
        }}
      >
        Saber mais
      </Button>
    </ContentSection>
  );
};

export default BusinessSection;
